<script setup lang="ts">
import { computed } from 'vue'
import { useGameStore } from '@/stores/gameStore.ts'
import PlayerName from '@/components/Objects/PlayerName.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const gameStore = useGameStore()

const topPlayerId = computed(() => {
  if (!gameStore.leaderboard || !Array.isArray(gameStore.leaderboard) || gameStore.leaderboard.length === 0) {
    return null
  }

  const topPlayer = gameStore.leaderboard.find((player: any) => player.position === 1)
  return topPlayer?.player_id || null
})
</script>

<template>
  <div class="">
    <div class="p-6">
      <div class="text-center space-y-4">
        <div class="text-6xl mb-4">🏆</div>

        <h2 class="text-3xl font-bold text-yellow-400">{{ t('tutorial.gameFinished.gameOver') }}</h2>

        <p class="text-lg text-metal-300">
          <template v-if="topPlayerId">
            <i18n-t keypath="tutorial.gameFinished.congratulations" tag="span">
              <template #player>
                <PlayerName :player-id="topPlayerId" />
              </template>
            </i18n-t>
          </template>
          <template v-else>
            {{ t('tutorial.gameFinished.gameConcluded') }}
          </template>
        </p>

        <div class="bg-metal-800 p-4 rounded-lg mt-6">
          <p class="text-metal-400">
            {{ t('tutorial.gameFinished.thankYou') }}
          </p>
        </div>

        <div class="mt-6 text-sm text-metal-500">
          <p>{{ t('tutorial.gameFinished.anotherChance') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>